import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  useTheme,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import CreditCardIcon from "@mui/icons-material/CreditCard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import {
  ApplicationType,
  entity_id,
  getGeolocation,
  location,
  Platform,
} from "../Utils/Const";
import { baseapi } from "../Environmentalurl";
import { format } from "date-fns";
import ErrorIcon from "@mui/icons-material/Error";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import DashboardHeader from "../Dashboard/DashboardHeader";
import api from "../Utils/Api";

export default function Linkpan() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const navigate = useNavigate();
  const ip = useIPAddress();
  const handlehomenavigation = () => {
    navigate("/profile-settings");
  };

  const [pan, setPan] = useState("");
  const [dob, setDob] = useState(null);
  const [existingPan, setExistingPan] = useState("");
  const [dialog, setDialog] = useState({
    open: false,
    title: "",
    message: "",
    type: "",
  });

  // ✅ Read pan from sessionStorage
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("pan");
      if (raw) {
        const panValue = JSON.parse(raw);
        if (panValue) {
          setExistingPan(panValue);
          setPan(panValue);
        }
      }
    } catch (e) {
      console.error("Failed to read pan from session:", e);
    }
  }, []);

  const handleChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/\s/g, "");
    if (value.length <= 10) {
      setPan(value);
    }
  };

  const isValidPAN = (value) => /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value);

  const handleVerify = async () => {
    if (!isValidPAN(pan)) {
      setDialog({
        open: true,
        title: "Invalid PAN",
        message: "Please enter a valid 10-character PAN number.",
        type: "error",
      });
      return;
    }

    if (!dob) {
      setDialog({
        open: true,
        title: "Missing Date of Birth",
        message: "Please select your date of birth.",
        type: "error",
      });
      return;
    }

    const mobilenumber = JSON.parse(
      sessionStorage.getItem("mobileNumber") || "null",
    );
    const name = JSON.parse(sessionStorage.getItem("NameOnCard") || "null");
    const sessionID = JSON.parse(sessionStorage.getItem("SessionID") || "null");

    const payload = {
      ReqType: "Jan_Aadhaar_eWallet_PAN_Verification",
      ApplicationType: ApplicationType,
      GeoLocation: location,
      MachineID: ip,
      Mobilenumber: mobilenumber,
      PANNumber: pan,
      Name: name,
      Fathername: "",
      Dob: dob ? format(dob, "dd/MM/yyyy") : "",
      Platform: Platform,
      EntityID: entity_id,
      SessionID: sessionID,
      Purpose: "Upgrade Wallet",
    };

    try {
      const response = await api.post(
        `${baseapi}/JanaadhaareWalletPANVerificationasd`,
        payload,
      );

      const { Response_Code, Message } = response.data;

      setDialog({
        open: true,
        title: Response_Code === "2810" ? "Success" : "Verification Failed",
        message: Message,
        type: Response_Code === "2810" ? "success" : "error",
      });
    } catch (error) {
      setDialog({
        open: true,
        title: "API Error",
        message: "Something went wrong. Please try again later.",
        type: "error",
      });
    }
  };

  return (
    <>
      <DashboardHeader />
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          backgroundColor: isDark ? "#0a122a" : "#f4f7fb",
          p: { xs: 2, md: 4 },
        }}
      >
        {/* CENTER CARD */}
        <Box
          mt={6}
          display="flex"
          justifyContent="center"
          alignItems="center"
          px={2}
        >
          <Paper
            elevation={3}
            sx={{
              width: "100%",
              maxWidth: "480px",
              p: { xs: 3, md: 4 },
              borderRadius: "20px",
              textAlign: "center",
              backgroundColor: isDark ? "#1c2536" : "#ffffff",
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5} mb={4}>
              <IconButton
                onClick={handlehomenavigation}
                sx={{ bgcolor: "white", color: "#1e5fd8" }}
              >
                <ArrowBackIosNewOutlined />
              </IconButton>
              <Typography variant="h5" fontWeight="bold">
                Verify Your PAN Details
              </Typography>
            </Box>

            {/* PAN FIELD LABEL */}
            <Typography
              textAlign="left"
              mb={1}
              fontSize="14px"
              color={isDark ? "#e0e0e0" : "#444"}
            >
              PAN Card Number
            </Typography>

            {/* PAN FIELD */}
            <Box sx={{ position: "relative" }}>
              <TextField
                fullWidth
                placeholder="ABCDE1234F"
                value={pan}
                autoComplete="off"
                onChange={(e) => setPan(e.target.value.toUpperCase())}
                inputProps={{ maxLength: 10 }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    backgroundColor: isDark ? "#0f172a" : "#f7f9fc",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CreditCardIcon sx={{ color: "text.secondary" }} />
                    </InputAdornment>
                  ),
                }}
              />

              {/* CHARACTER COUNT */}
              <Typography
                sx={{
                  position: "absolute",
                  right: 10,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "text.secondary",
                  fontSize: "12px",
                }}
              >
                {pan.length}/10
              </Typography>
            </Box>

            {/* SUBTEXT */}
            <Typography mt={1} textAlign="left" fontSize="13px" color="#1e5fd8">
              Enter your 10-digit Permanent Account Number
            </Typography>

            {/* ✅ Already verified message */}
            {existingPan && (
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                mt={1}
                p={1.5}
                sx={{
                  borderRadius: "8px",
                  backgroundColor: isDark ? "#1a3320" : "#e8f5e9",
                }}
              >
                <CheckCircleIcon sx={{ color: "#22c55e", fontSize: 20 }} />
                <Typography fontSize="13px" color="#22c55e" fontWeight={600}>
                  Your PAN is already verified
                </Typography>
              </Box>
            )}

            {/* ✅ DOB — hidden when PAN already verified */}
            {!existingPan && (
              <>
                <Typography
                  mt={3}
                  mb={1}
                  textAlign="left"
                  fontSize="14px"
                  color={isDark ? "#e0e0e0" : "#444"}
                >
                  Date of Birth
                </Typography>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={dob}
                    onChange={(newValue) => setDob(newValue)}
                    format="dd/MM/yyyy"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        placeholder: "DD/MM/YYYY",
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                            backgroundColor: isDark ? "#0f172a" : "#f7f9fc",
                          },
                        },
                        InputProps: {
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalendarMonthIcon
                                sx={{ color: "text.secondary" }}
                              />
                            </InputAdornment>
                          ),
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </>
            )}

            {/* ✅ BUTTON — disabled when PAN already verified */}
            <Button
              variant="contained"
              fullWidth
              disabled={!!existingPan}
              sx={{
                mt: 4,
                py: 1.4,
                fontWeight: "bold",
                borderRadius: "10px",
                background: "linear-gradient(90deg, #00c853, #4dff76)",
                color: "#fff",
                boxShadow: "0 4px 10px rgba(0,200,83,0.3)",
                textTransform: "none",
                "&:hover": {
                  background: "linear-gradient(90deg, #00b34a, #3af06a)",
                },
              }}
              onClick={handleVerify}
            >
              Verify & Update
            </Button>
          </Paper>
        </Box>
      </Box>

      <Dialog
        open={dialog.open}
        onClose={() => setDialog({ ...dialog, open: false })}
        maxWidth="xs"
        fullWidth
      >
        <Box textAlign="center" py={3}>
          <Box
            display="inline-flex"
            justifyContent="center"
            alignItems="center"
            width={70}
            height={70}
            borderRadius="50%"
            bgcolor={dialog.type === "success" ? "#22c55e" : "#f44336"}
            color="white"
            mx="auto"
          >
            {dialog.type === "success" ? (
              <CheckCircleIcon sx={{ fontSize: 40 }} />
            ) : (
              <ErrorIcon sx={{ fontSize: 40 }} />
            )}
          </Box>
          <DialogTitle>{dialog.title}</DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="text.secondary">
              {dialog.message}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={() => setDialog({ ...dialog, open: false })}
              variant="contained"
              color={dialog.type === "success" ? "success" : "error"}
            >
              OK
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
}